import {
  ANY_TIME_OF_DAY,
  type IOneTimeActivitySchedule,
} from "@/api/Activities";
import { z } from "zod";
import { machineFormat } from "@medoma/models/date-and-time";

/**
 * Generates an occurrenceId from a one-time activity schedule.
 * @param schedule - The one-time activity schedule.
 * @returns The occurrenceId according to BE's model.
 */
export const getActivityOccurrenceIdFromActivitySchedule = (
  schedule: IOneTimeActivitySchedule,
) => {
  // One time activity rescheduling must use rescheduleOccurrence endpoint, which requires an occurrenceId
  // The occurrenceId is a combination of the date and time, formatted as yyyyMMdd-HHmm or yyyyMMdd-anytimeofday
  // Even when instantiated (where occurrenceId becomes a uuid), the yyyyMMdd-HHmm or yyyyMMdd-anytimeofday format can still be used to identify the occurrence - BE resolves it.
  const occurrenceIdSchema = z.union([
    z.string().regex(/^\d{8}-anytimeofday$/),
    z.string().regex(/^\d{8}-\d{4}$/),
  ]);
  const occurrenceId = occurrenceIdSchema.parse(
    `${machineFormat(schedule.date, "yyyyMMdd")}-${schedule.time === ANY_TIME_OF_DAY ? "anytimeofday" : schedule.time.replace(/:/g, "")}`,
  );

  return occurrenceId;
};
